/**
 * @fileoverview POST handler for the "/engagement/intelligent_delivery_preview/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementIntelligentDeliveryPreviewAppGroupIdCacheKeys } from "./constants";
import type {
  PostEngagementIntelligentDeliveryPreviewAppGroupIdProps,
  EngagementIntelligentDeliveryPreviewResult,
} from "./types";

export const postEngagementIntelligentDeliveryPreview = reactQueryMutationAdapter(
  engagementIntelligentDeliveryPreviewAppGroupIdCacheKeys,
  (
    props: PostEngagementIntelligentDeliveryPreviewAppGroupIdProps
  ): Promise<EngagementIntelligentDeliveryPreviewResult> => {
    return fetch(`/engagement/intelligent_delivery_preview/${props.appGroupId}`, "POST", props);
  }
);
